import { Controller } from '@hotwired/stimulus';
import { Subscription } from 'rxjs';
import { MainMenuToggleService } from 'core-app/core/main-menu/main-menu-toggle.service';

export default class MainMenuToggleController extends Controller {
  static targets = [
    'button',
  ];

  declare readonly buttonTarget:HTMLButtonElement;

  private subscription:Subscription|undefined;

  connect() {
    void this.toggleService().then((service) => {
      service.initializeMenu();

      this.subscription = service.titleData$.subscribe((title) => {
        this.buttonTarget.title = title;
        this.buttonTarget.setAttribute('aria-label', title);
        this.buttonTarget.setAttribute('aria-expanded', String(service.showNavigation));
      });
    });
  }

  disconnect() {
    this.subscription?.unsubscribe();
  }

  toggle(event:MouseEvent) {
    event.preventDefault();
    void this.toggleService().then((service) => service.toggleNavigation());
  }

  private toggleService():Promise<MainMenuToggleService> {
    return window.OpenProject.getPluginContext()
      .then((pluginContext) => pluginContext.injector.get(MainMenuToggleService));
  }
}
